import { render, staticRenderFns } from "./MemberMenu.vue?vue&type=template&id=622cf344&scoped=true&"
import script from "./MemberMenu.vue?vue&type=script&lang=js&"
export * from "./MemberMenu.vue?vue&type=script&lang=js&"
import style0 from "./MemberMenu.vue?vue&type=style&index=0&id=622cf344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622cf344",
  null
  
)

export default component.exports